require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
// import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';

import { InertiaProgress } from '@inertiajs/progress';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import SubdomainLink from '@/Components/SubdomainLink';

const isProd = process.env.NODE_ENV === 'production';
const el = document.getElementById('app');
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Visual Quote Pro';

createInertiaApp({
  title: (title) => {
    return `${title} - ${appName}`;
  },
  resolve: (name) => import(`./Pages/${name}.vue`),
  setup({ el, app, props, plugin }) {
    const getSvgHtml = require.context('../svgs/', true, /\.svg$/);
    // Configure and Mount Vue App
    if (isProd) {
      Bugsnag.start({
        apiKey: '9bf28ae55a2631a8b83c547cef422fc3',
        plugins: [new BugsnagPluginVue()],
      });
    }

    return createApp({ render: () => h(app, props) })
      .use(plugin)
      .use(isProd ? Bugsnag.getPlugin('vue') : () => {})
      .component('subdomain-link', SubdomainLink)
      .mixin({
        methods: {
          route,
          $getSvgHtml: (name) => {
            return getSvgHtml(`./${name}.svg`);
          },
          $getIconHtml: (name, lib = null) => {
            let path = lib ? `./icons/${lib}/${name}.svg` : `./icons/${name}.svg`;
            return getSvgHtml(path);
          },
        },
      })
      .mount(el);
  },
});

InertiaProgress.init({ color: '#00aba9' });

// Handle inertia errors
if (process.env.NODE_ENV === 'production') {
  let justLoaded = new Date().getTime();
  Inertia.on('invalid', (event) => {
    event.preventDefault();

    if (event?.isTrusted !== false) Bugsnag.notify(event);
    console.error(event);

    setTimeout(() => {
      if (new Date().getTime() - justLoaded > 1000) {
        document.location.reload(true);
      }
    }, 500);
  });
}
